import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextInput";
import LocalCombobox from "../Reusable/ComboBox";
import MultipleSelectField from "../Reusable/MultipleCountryField";
import SwitchButton from "../Reusable/SwitchButton";
const CodeData = [
  {
    name: "USD",
    id: "USD",
  },
  {
    name: "NPR",
    id: "NPR",
  },
];

const GroupForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
  control,
  watch,
  isEdit = true,
}: any) => {
  return (
    <>
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <MultipleSelectField
          errors={errors?.countries}
          label={"Country"}
          queryKey={"countries-list"}
          register={register("countries ")}
          setValue={setValue}
          watch={watch}
          props={{
            level: 0,
          }}
          url={APIS.LOCATION}
          getValues={getValues}
          clearErrors={clearErrors}
          name={"countries"}
          value={getValues("countries")}
        />
        <LocalCombobox
          label={"Currency"}
          placeholder={"Search currency"}
          props={{}}
          register={register("code")}
          control={control}
          errors={errors?.code}
          name={"code"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          data={CodeData}
        />
      </div>
      {/* <div className={tw`mt-4 mx-4 flex items-center justify-end gap-2` }>
        <span>
        Is Rest Country?:
        </span>
      <SwitchButton
        value={!!isRest}
        onChange={(val) => {
          setValue("is_rest", val, { shouldDirty: true });
        }}
      />

      </div> */}
    </>
  );
};

export default GroupForm;
